export const packages = [
  {
    id: 1,
    title: "Timeless Europe",
    subtitle: "Classic Cities Expedition",
    duration: "6N / 7D",
    type: "Group Departure",
    airline: "Lufthansa",
    image: "https://images.unsplash.com/photo-1467269204594-9661b134dd2b?w=800&q=80",
    destinations: ["2N Vienna", "1N Budapest", "2N Prague", "1N Frankfurt"],
    highlights: ["City tour: Vienna, Budapest, Prague", "English Speaking Guide", "Lufthansa Airlines"],
    originalPrice: null,
    price: 94522,
    theme: ["Cultural", "Heritage"],
    packageType: "Group",
    flightIncluded: true,
    amenities: ["hotel", "transport", "guide", "meals"],
  },
  {
    id: 2,
    title: "Paris & Swiss Getaway",
    subtitle: "Summer 2026",
    duration: "6N / 7D",
    type: "Group Departure",
    airline: null,
    image: "https://images.unsplash.com/photo-1499856871958-5b9627545d1a?w=800&q=80",
    destinations: ["3N Paris", "3N Switzerland"],
    highlights: ["Mt. Titlis with Cliff Walk", "Romantic River Seine Cruise", "Eiffel Tower Visit"],
    originalPrice: 157050,
    price: 145824,
    theme: ["Romantic", "Adventure"],
    packageType: "Group",
    flightIncluded: true,
    amenities: ["hotel", "transport", "guide", "meals"],
    badge: "EMT Exclusive",
  },
  {
    id: 3,
    title: "Magical Swiss & Paris Delight",
    subtitle: "Summer 2026",
    duration: "7N / 8D",
    type: "Group Departure",
    airline: null,
    image: "https://images.unsplash.com/photo-1431274172761-fca41d930114?w=800&q=80",
    destinations: ["3N Paris", "1N Geneva", "2N Engelberg", "1N Zurich"],
    highlights: ["Mini Train Ride in Vaduz", "Versailles Palace", "Romantic River Seine Cruise", "Visit Iconic Eiffel Tower"],
    originalPrice: 246857,
    price: 191401,
    theme: ["Romantic", "Cultural"],
    packageType: "Group",
    flightIncluded: true,
    amenities: ["hotel", "transport", "guide", "meals"],
    badge: "EMT Exclusive",
  },
  {
    id: 4,
    title: "Central European Splendours",
    subtitle: "Summer 2026",
    duration: "10N / 11D",
    type: "Group Departure",
    airline: null,
    image: "https://images.unsplash.com/photo-1502602898657-3e91760cbb34?w=800&q=80",
    destinations: ["3N Paris", "1N Amsterdam", "1N Mannheim", "3N Engelberg"],
    highlights: ["Louvre Museum Visit", "Anne Frank House", "Rhine Valley Cruise", "Swiss Alps Tour"],
    originalPrice: 312000,
    price: 265000,
    theme: ["Cultural", "Heritage"],
    packageType: "Group",
    flightIncluded: true,
    amenities: ["hotel", "transport", "guide", "meals"],
    badge: "EMT Exclusive",
  },
  {
    id: 5,
    title: "European Extravaganza",
    subtitle: "Summer 2026",
    duration: "12N / 13D",
    type: "Group Departure",
    airline: null,
    image: "https://images.unsplash.com/photo-1528360983277-13d401cdc186?w=800&q=80",
    destinations: ["3N Paris", "1N Amsterdam", "1N Mannheim", "3N Engelberg"],
    highlights: ["Versailles Palace Gardens", "Keukenhof Tulip Gardens", "Black Forest Drive", "Jungfrau Railway"],
    originalPrice: 398000,
    price: 334500,
    theme: ["Adventure", "Cultural"],
    packageType: "Group",
    flightIncluded: true,
    amenities: ["hotel", "transport", "guide", "meals"],
    badge: "EMT Exclusive",
  },
  {
    id: 6,
    title: "Grand Tour of Europe",
    subtitle: "Summer 2026",
    duration: "14N / 15D",
    type: "Group Departure",
    airline: null,
    image: "https://images.unsplash.com/photo-1513635269975-59663e0ac1ad?w=800&q=80",
    destinations: ["2N London", "3N Paris", "1N Amsterdam", "1N Mannheim"],
    highlights: ["Buckingham Palace", "Thames River Cruise", "Eiffel Tower", "Swiss Glacier Walk"],
    originalPrice: 512000,
    price: 425000,
    theme: ["Luxury", "Heritage"],
    packageType: "Group",
    flightIncluded: true,
    amenities: ["hotel", "transport", "guide", "meals"],
    badge: "EMT Exclusive",
  },
  {
    id: 7,
    title: "Swiss Alps Adventure",
    subtitle: "Peak Season 2026",
    duration: "5N / 6D",
    type: "Group Departure",
    airline: "Swiss Air",
    image: "https://images.unsplash.com/photo-1506905925346-21bda4d32df4?w=800&q=80",
    destinations: ["2N Zurich", "2N Interlaken", "1N Lucerne"],
    highlights: ["Jungfraujoch – Top of Europe", "Paragliding in Interlaken", "Lake Lucerne Cruise"],
    originalPrice: 198000,
    price: 165000,
    theme: ["Adventure", "Nature"],
    packageType: "Group",
    flightIncluded: true,
    amenities: ["hotel", "transport", "guide"],
  },
  {
    id: 8,
    title: "Italian Renaissance Journey",
    subtitle: "Spring 2026",
    duration: "8N / 9D",
    type: "Group Departure",
    airline: null,
    image: "https://images.unsplash.com/photo-1515542622106-78bda8ba0e5b?w=800&q=80",
    destinations: ["2N Rome", "2N Florence", "2N Venice", "2N Milan"],
    highlights: ["Vatican Museums & Sistine Chapel", "Uffizi Gallery", "Gondola Ride in Venice", "Milan Fashion District"],
    originalPrice: 285000,
    price: 238000,
    theme: ["Cultural", "Luxury"],
    packageType: "Group",
    flightIncluded: false,
    amenities: ["hotel", "transport", "guide", "meals"],
    badge: "EMT Exclusive",
  },
  {
    id: 9,
    title: "Scandinavia Northern Lights",
    subtitle: "Winter 2026",
    duration: "7N / 8D",
    type: "Group Departure",
    airline: "Scandinavian Airlines",
    image: "https://images.unsplash.com/photo-1531366936337-7c912a4589a7?w=800&q=80",
    destinations: ["2N Oslo", "2N Bergen", "3N Tromsø"],
    highlights: ["Northern Lights Safari", "Fjord Cruise", "Dog Sledding", "Ice Hotel Experience"],
    originalPrice: 445000,
    price: 378000,
    theme: ["Adventure", "Nature"],
    packageType: "Group",
    flightIncluded: true,
    amenities: ["hotel", "transport", "guide"],
  },
];

export const themes = ["All", "Cultural", "Romantic", "Adventure", "Nature", "Luxury", "Heritage"];
export const durations = ["All", "1-5 Days", "6-8 Days", "9-12 Days", "13+ Days"];
export const priceRanges = ["All", "Under ₹1,00,000", "₹1,00,000 – ₹2,00,000", "₹2,00,000 – ₹3,50,000", "Above ₹3,50,000"];
export const packageTypes = ["All", "Group", "Private", "Honeymoon"];
export const sortOptions = ["Featured", "Price: Low to High", "Price: High to Low", "Duration: Short to Long", "Duration: Long to Short"];

export function formatPrice(price) {
  return new Intl.NumberFormat("en-IN").format(price);
}

export function getDurationDays(durationStr) {
  const match = durationStr.match(/(\d+)N/);
  return match ? parseInt(match[1]) : 0;
}

export function filterAndSort(packages, filters) {
  let result = [...packages];

  if (filters.theme !== "All") {
    result = result.filter((p) => p.theme.includes(filters.theme));
  }

  if (filters.packageType !== "All") {
    result = result.filter((p) => p.packageType === filters.packageType);
  }

  if (filters.price !== "All") {
    result = result.filter((p) => {
      if (filters.price === "Under ₹1,00,000") return p.price < 100000;
      if (filters.price === "₹1,00,000 – ₹2,00,000") return p.price >= 100000 && p.price <= 200000;
      if (filters.price === "₹2,00,000 – ₹3,50,000") return p.price > 200000 && p.price <= 350000;
      if (filters.price === "Above ₹3,50,000") return p.price > 350000;
      return true;
    });
  }

  if (filters.duration !== "All") {
    result = result.filter((p) => {
      const days = getDurationDays(p.duration);
      if (filters.duration === "1-5 Days") return days <= 5;
      if (filters.duration === "6-8 Days") return days >= 6 && days <= 8;
      if (filters.duration === "9-12 Days") return days >= 9 && days <= 12;
      if (filters.duration === "13+ Days") return days >= 13;
      return true;
    });
  }

  if (filters.search) {
    const q = filters.search.toLowerCase();
    result = result.filter(
      (p) =>
        p.title.toLowerCase().includes(q) ||
        p.destinations.some((d) => d.toLowerCase().includes(q)) ||
        p.highlights.some((h) => h.toLowerCase().includes(q))
    );
  }

  switch (filters.sort) {
    case "Price: Low to High":
      result.sort((a, b) => a.price - b.price);
      break;
    case "Price: High to Low":
      result.sort((a, b) => b.price - a.price);
      break;
    case "Duration: Short to Long":
      result.sort((a, b) => getDurationDays(a.duration) - getDurationDays(b.duration));
      break;
    case "Duration: Long to Short":
      result.sort((a, b) => getDurationDays(b.duration) - getDurationDays(a.duration));
      break;
    default:
      break;
  }

  return result;
}